export default __webpack_public_path__ + "static/projects-banner-10e462c8379cfd1f577a50365deb97b6.svg";